import PositionMarkerMemo from './PositionMarker'

export default PositionMarkerMemo
